import React from 'react';
import { Check, Coins } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useCurrency } from '@/contexts/CurrencyContext';

/** Stripe-checkout token packages picker (Starter / Pro / Studio).
 *  Renders the package cards a writer can pick before checkout. */
export function PackagePicker({ packages, selectedId, onSelect }) {
  const { format } = useCurrency();
  return (
    <>
      <h3 className="mt-5 text-[12px] font-semibold uppercase tracking-wider text-muted-foreground">
        Choose a package
      </h3>
      <div className="mt-2 grid gap-3 md:grid-cols-3">
        {packages.map((p) => {
          const active = selectedId === p.id;
          return (
            <button
              key={p.id}
              data-testid={`pkg-${p.id}`}
              onClick={() => onSelect(p.id)}
              className={cn(
                'relative flex flex-col rounded-md border bg-card p-4 text-left transition-all',
                active ? 'border-primary shadow-panel-active' : 'border-border hover:border-primary/50'
              )}
            >
              {p.best && (
                <span className="absolute -top-2 left-3 rounded-sm bg-primary px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-primary-foreground">
                  Best value
                </span>
              )}
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-[13px] font-semibold">{p.name}</div>
                  <div className="text-[11px] text-muted-foreground">{p.desc}</div>
                </div>
                {active && <Check className="h-4 w-4 text-primary" />}
              </div>
              <div className="mt-3 flex items-baseline gap-1">
                <span className="text-[22px] font-semibold">{format(Math.round(p.price * 100))}</span>
                <span className="text-[10.5px] text-muted-foreground">one-time</span>
              </div>
              <div className="mt-2 flex items-center gap-1 font-mono-stat text-[11.5px]">
                <Coins className="h-3.5 w-3.5 text-primary" /> +{(p.tokens / 1_000_000).toFixed(0)}M tokens
              </div>
            </button>
          );
        })}
      </div>
    </>
  );
}
